// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85ec4f56","732":"713b26f7","977":"603cca9f"}[chunkId] + ".chunk.js";
};